import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import vendorService from '../../services/vendorService';
import './VendorOnboarding.css';
import { toast } from 'react-toastify';
import VendorStore from './VendorStore';

const VendorOnboarding = () => {
  const { id } = useParams();

  const navigate = useNavigate();
  const [currentStep, setCurrentStep] = useState(1);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const { selectedVendor, setSelectedVendor, clearSelectedVendor } = VendorStore();

  const [formData, setFormData] = useState({
    // Basic Information
    company_name: '',
    legal_name: '',
    vendor_type: 'Company',
    category: 'Other',
    tax_id: '',
    registration_number: '',

    // Contact Information
    email: '',
    phone: '',
    website: '',
    address: '',
    city: '',
    state: '',
    country: '',
    postal_code: '',

    // Primary Contact
    primary_contact: {
      first_name: '',
      last_name: '',
      title: '',
      email: '',
      phone: '',
      contact_type: 'Primary'
    },

    // Banking Information
    bank_name: '',
    bank_account_number: '',
    bank_routing_number: '',
    payment_terms: 'Net 30',
    currency: 'USD',

    // Additional Information
    certifications: [],
    notes: ''
  });

  const steps = [
    { number: 1, title: 'Basic Information', icon: 'fa-building' },
    { number: 2, title: 'Contact Details', icon: 'fa-address-card' },
    { number: 3, title: 'Primary Contact', icon: 'fa-user' },
    { number: 4, title: 'Banking Information', icon: 'fa-university' },
    { number: 5, title: 'Review & Submit', icon: 'fa-check-circle' }
  ];

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (name.startsWith('primary_contact.')) {
      const field = name.split('.')[1];
      setFormData(prev => ({
        ...prev,
        primary_contact: {
          ...prev.primary_contact,
          [field]: value
        }
      }));
    } else {
      setFormData(prev => ({
        ...prev,
        [name]: value
      }));
    }
  };

  const validateStep = (step) => {
    switch (step) {
      case 1:
        return formData.company_name && formData.vendor_type && formData.category;
      case 2:
        return formData.email && formData.phone && formData.address;
      case 3:
        return formData.primary_contact.first_name &&
          formData.primary_contact.last_name &&
          formData.primary_contact.email;
      case 4:
        return formData.bank_name && formData.payment_terms;
      default:
        return true;
    }
  };

  const handleNext = () => {
    if (validateStep(currentStep)) {
      setCurrentStep(prev => Math.min(prev + 1, 5));
      setError(null);
    } else {
      setError('Please fill in all required fields');
    }
  };

  const handlePrevious = () => {
    setCurrentStep(prev => Math.max(prev - 1, 1));
    setError(null);
  };

  useEffect(() => {
    if (id && selectedVendor) {
      loadVendorData()
    }

  }, [id], selectedVendor);


  const loadVendorData = async () => {
    console.log("seteee data")


    setFormData({
      company_name: selectedVendor?.company_name || '',
      legal_name: selectedVendor?.legal_name || '',
      vendor_type: selectedVendor?.vendor_type || 'Task',
      category: selectedVendor?.category || 'To Do',
      tax_id: selectedVendor?.tax_id || 'Medium',
      registration_number: selectedVendor?.registration_number || '',
      email: selectedVendor?.email || '',
      phone: selectedVendor?.phone || '',
      website: selectedVendor?.website || '',
      address: selectedVendor?.address || '',
      city: selectedVendor?.city || '',
      state: selectedVendor?.state || '',
      country: selectedVendor?.country || '',
      postal_code: selectedVendor?.postal_code || '',
      country: selectedVendor?.country || '',
      country: selectedVendor?.country || '',

      primary_contact: {
        first_name: selectedVendor.contacts[0]?.first_name || '',
        last_name: selectedVendor.contacts[0]?.last_name || '',
        title: selectedVendor.contacts[0]?.title || '',
        email: selectedVendor.contacts[0]?.email || '',
        phone: selectedVendor.contacts[0]?.phone || '',
        contact_type: selectedVendor.contacts[0]?.contact_type || 'Primary'
      },
      bank_name: selectedVendor?.bank_name || '',
      bank_account_number: selectedVendor?.bank_account_number || '',
      bank_routing_number: selectedVendor?.bank_routing_number || '',
      payment_terms: selectedVendor?.payment_terms || 'Net 30',
      currency: selectedVendor?.currency || 'USD',
    });

  };



  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    try {
      // toast.success('Vendor onboarded successfully!');
      const submitData = {
        ...formData
      }

      if (id) {
        const vendor = await vendorService.updateVendor(id, formData);
        toast.success('Vendor updated successfully!');
        navigate(`/app/vendors/${vendor.id}`);
      } else {
        const vendor = await vendorService.createVendor(formData);
        toast.success('Vendor onboarded successfully!');
        navigate(`/app/vendors/${vendor.id}`);
      }


    } catch (err) {
      toast.error('Failed to onboard vendor. Please try again.');
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const renderStepContent = () => {
    switch (currentStep) {
      case 1:
        return (
          <div className="form-section">
            <h3>Basic Information</h3>
            <div className="form-grid">
              <div className="form-group">
                <label>Company Name *</label>
                <input
                  type="text"
                  name="company_name"
                  value={formData.company_name}
                  onChange={handleInputChange}
                  required
                />
              </div>
              <div className="form-group">
                <label>Legal Name</label>
                <input
                  type="text"
                  name="legal_name"
                  value={formData.legal_name}
                  onChange={handleInputChange}
                />
              </div>
              <div className="form-group">
                <label>Client Type *</label>
                <select
                  name="vendor_type"
                  value={formData.vendor_type}
                  onChange={handleInputChange}
                  required
                >
                  <option value="Individual">Individual</option>
                  <option value="Company">Company</option>
                  <option value="Partnership">Partnership</option>
                  <option value="Corporation">Corporation</option>
                </select>
              </div>
              <div className="form-group">
                <label>Category *</label>
                <select
                  name="category"
                  value={formData.category}
                  onChange={handleInputChange}
                  required
                >
                  <option value="IT Services">IT Services</option>
                  <option value="Consulting">Consulting</option>
                  <option value="Manufacturing">Manufacturing</option>
                  <option value="Logistics">Logistics</option>
                  <option value="Marketing">Marketing</option>
                  <option value="HR Services">HR Services</option>
                  <option value="Legal">Legal</option>
                  <option value="Financial">Financial</option>
                  <option value="Stock Exchange">Stock Exchange</option>
                  <option value="Other">Other</option>
                </select>
              </div>
              <div className="form-group">
                <label>Tax ID</label>
                <input
                  type="text"
                  name="tax_id"
                  value={formData.tax_id}
                  onChange={handleInputChange}
                />
              </div>
              <div className="form-group">
                <label>Registration Number</label>
                <input
                  type="text"
                  name="registration_number"
                  value={formData.registration_number}
                  onChange={handleInputChange}
                />
              </div>
            </div>
          </div>
        );

      case 2:
        return (
          <div className="form-section">
            <h3>Company Contact Details</h3>
            <div className="form-grid">
              <div className="form-group">
                <label>Email *</label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleInputChange}
                  required
                />
              </div>
              <div className="form-group">
                <label>Phone *</label>
                <input
                  type="tel"
                  name="phone"
                  value={formData.phone}
                  onChange={handleInputChange}
                  required
                />
              </div>
              <div className="form-group">
                <label>Website</label>
                <input
                  type="url"
                  name="website"
                  value={formData.website}
                  onChange={handleInputChange}
                />
              </div>
              <div className="form-group full-width">
                <label>Address *</label>
                <textarea
                  name="address"
                  value={formData.address}
                  onChange={handleInputChange}
                  rows="3"
                  required
                />
              </div>
              <div className="form-group">
                <label>City</label>
                <input
                  type="text"
                  name="city"
                  value={formData.city}
                  onChange={handleInputChange}
                />
              </div>
              <div className="form-group">
                <label>State/Province</label>
                <input
                  type="text"
                  name="state"
                  value={formData.state}
                  onChange={handleInputChange}
                />
              </div>
              <div className="form-group">
                <label>Country</label>
                <input
                  type="text"
                  name="country"
                  value={formData.country}
                  onChange={handleInputChange}
                />
              </div>
              <div className="form-group">
                <label>Postal Code</label>
                <input
                  type="text"
                  name="postal_code"
                  value={formData.postal_code}
                  onChange={handleInputChange}
                />
              </div>
            </div>
          </div>
        );

      case 3:
        return (
          <div className="form-section">
            <h3>Primary Contact Person</h3>
            <div className="form-grid">
              <div className="form-group">
                <label>First Name *</label>
                <input
                  type="text"
                  name="primary_contact.first_name"
                  value={formData.primary_contact.first_name}
                  onChange={handleInputChange}
                  required
                />
              </div>
              <div className="form-group">
                <label>Last Name *</label>
                <input
                  type="text"
                  name="primary_contact.last_name"
                  value={formData.primary_contact.last_name}
                  onChange={handleInputChange}
                  required
                />
              </div>
              <div className="form-group">
                <label>Title/Position</label>
                <input
                  type="text"
                  name="primary_contact.title"
                  value={formData.primary_contact.title}
                  onChange={handleInputChange}
                />
              </div>
              <div className="form-group">
                <label>Email *</label>
                <input
                  type="email"
                  name="primary_contact.email"
                  value={formData.primary_contact.email}
                  onChange={handleInputChange}
                  required
                />
              </div>
              <div className="form-group">
                <label>Phone</label>
                <input
                  type="tel"
                  name="primary_contact.phone"
                  value={formData.primary_contact.phone}
                  onChange={handleInputChange}
                />
              </div>
            </div>
          </div>
        );

      case 4:
        return (
          <div className="form-section">
            <h3>Banking Information</h3>
            <div className="form-grid">
              <div className="form-group">
                <label>Bank Name *</label>
                <input
                  type="text"
                  name="bank_name"
                  value={formData.bank_name}
                  onChange={handleInputChange}
                  required
                />
              </div>
              <div className="form-group">
                <label>Account Number</label>
                <input
                  type="text"
                  name="bank_account_number"
                  value={formData.bank_account_number}
                  onChange={handleInputChange}
                />
              </div>
              <div className="form-group">
                <label>Routing Number</label>
                <input
                  type="text"
                  name="bank_routing_number"
                  value={formData.bank_routing_number}
                  onChange={handleInputChange}
                />
              </div>
              <div className="form-group">
                <label>Payment Terms *</label>
                <select
                  name="payment_terms"
                  value={formData.payment_terms}
                  onChange={handleInputChange}
                  required
                >
                  <option value="Net 15">Net 15</option>
                  <option value="Net 30">Net 30</option>
                  <option value="Net 45">Net 45</option>
                  <option value="Net 60">Net 60</option>
                  <option value="Due on Receipt">Due on Receipt</option>
                </select>
              </div>
              <div className="form-group">
                <label>Currency</label>
                <select
                  name="currency"
                  value={formData.currency}
                  onChange={handleInputChange}
                >
                  <option value="USD">USD</option>
                  <option value="EUR">EUR</option>
                  <option value="GBP">GBP</option>
                  <option value="INR">INR</option>
                  <option value="CAD">CAD</option>
                </select>
              </div>
            </div>
          </div>
        );

      case 5:
        return (
          <div className="form-section review-section">
            <h3>Review & Submit</h3>
            <div className="review-grid">
              <div className="review-card">
                <h4><i className="fas fa-building"></i> Basic Information</h4>
                <p><strong>Company:</strong> {formData.company_name}</p>
                <p><strong>Type:</strong> {formData.vendor_type}</p>
                <p><strong>Category:</strong> {formData.category}</p>
              </div>
              <div className="review-card">
                <h4><i className="fas fa-address-card"></i> Contact Details</h4>
                <p><strong>Email:</strong> {formData.email}</p>
                <p><strong>Phone:</strong> {formData.phone}</p>
                <p><strong>Address:</strong> {formData.address}</p>
              </div>
              <div className="review-card">
                <h4><i className="fas fa-user"></i> Primary Contact</h4>
                <p><strong>Name:</strong> {formData.primary_contact.first_name} {formData.primary_contact.last_name}</p>
                <p><strong>Email:</strong> {formData.primary_contact.email}</p>
                <p><strong>Title:</strong> {formData.primary_contact.title || 'N/A'}</p>
              </div>
              <div className="review-card">
                <h4><i className="fas fa-university"></i> Banking Information</h4>
                <p><strong>Bank:</strong> {formData.bank_name}</p>
                <p><strong>Payment Terms:</strong> {formData.payment_terms}</p>
                <p><strong>Currency:</strong> {formData.currency}</p>
              </div>
            </div>
            <div className="form-group full-width">
              <label>Additional Notes</label>
              <textarea
                name="notes"
                value={formData.notes}
                onChange={handleInputChange}
                rows="4"
                placeholder="Any additional information about the vendor..."
              />
            </div>
          </div>
        );

      default:
        return null;
    }
  };

  return (
    <div className="vendor-onboarding">
      <div className="onboarding-header">
        <h1>Client Onboarding</h1>
        <p>Complete the following steps to onboard a new client</p>
      </div>

      {/* Progress Steps */}
      <div className="steps-container">
        {steps.map(step => (
          <div
            key={step.number}
            className={`step ${currentStep === step.number ? 'active' : ''
              } ${currentStep > step.number ? 'completed' : ''
              } `}
          >
            <div className="step-icon">
              <i className={`fas ${step.icon} `}></i>
            </div>
            <div className="step-content">
              <div className="step-number">Step {step.number}</div>
              <div className="step-title">{step.title}</div>
            </div>
          </div>
        ))}
      </div>

      {/* Form Content */}
      <div className="onboarding-form">
        {error && <div className="error-message">{error}</div>}

        <form onSubmit={handleSubmit}>
          {renderStepContent()}

          {/* Navigation Buttons */}
          <div className="form-actions">
            {currentStep > 1 && (
              <button
                type="button"
                onClick={handlePrevious}
                className="btn btn-secondary"
              >
                <i className="fas fa-arrow-left"></i> Previous
              </button>
            )}

            {currentStep < 5 ? (
              <button
                type="button"
                onClick={handleNext}
                className="btn btn-primary"
              >
                Next <i className="fas fa-arrow-right"></i>
              </button>
            ) : (
              <button
                type="submit"
                className="btn btn-success"
                disabled={loading}
              >
                {loading ? (
                  <>
                    <i className="fas fa-spinner fa-spin"></i> Submitting...
                  </>
                ) : (
                  <>
                    <i className="fas fa-check"></i> Submit client
                  </>
                )}
              </button>
            )}
          </div>
        </form>
      </div>
    </div>
  );
};

export default VendorOnboarding;

